import { IconLogin2 } from '@tabler/icons-react';
import { Box, Button, Group, useMatches } from '@mantine/core';

export function HeaderActionListUnauthenticated() {
  return (
    <>
      <Button
        variant={useMatches({ base: 'filled', lg: 'default' })}
        radius="md"
        component="a"
        href="/login"
        size="xs"
      >
        <Group gap={useMatches({ base: '0.3rem', lg: 0 })}>
          <Box hiddenFrom="lg">
            <IconLogin2 size={18} />
          </Box>
          Masuk
        </Group>
      </Button>
      <Button
        variant="filled"
        radius="md"
        component="a"
        href="/register"
        size="xs"
        visibleFrom="lg"
      >
        Daftar
      </Button>
    </>
  );
}
